import { BaseModel } from "./BaseModel";

export class ExtendModel extends BaseModel {

}
